import { render, staticRenderFns } from "./TariffCalculatorSwitchTab.vue?vue&type=template&id=1583c23d&"
import script from "./TariffCalculatorSwitchTab.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorSwitchTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports